module.exports = __webpack_public_path__ + "static/media/checklist-checked-box.42f13ad2.svg";